export default class Subject {
    /**
     * @param id: string
     * @param title: string
     * @param topics: Topic[]
     */
    constructor(
        id,
        title,
        topics
    ) {
        this.id = id;
        this.title = title;
        this.topics = topics;

        let questions = [];

        for (let topic of this.topics) {
            questions = questions.concat(topic.questions);
        }

        this.questions = questions;
    }

    findTopic(id) {
        return this.topics.find(topic => topic.id === id);
    }
}